import { Script } from './Script';
import register from './register';

const registeredComponent = register(Script);

export default registeredComponent;
